import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '@wlb/shared/analytics';
import {
  createNavigationDeduplicator,
  resolveAnalyticsRoute,
} from './analyticsRoutes';

const shouldTrackNavigation = createNavigationDeduplicator();

/** Tracks the initial route and every client-side React Router navigation. */
export function RouteAnalytics() {
  const { key, pathname } = useLocation();

  useEffect(() => {
    const navigationIdentity = `${key}:${pathname}`;
    if (!shouldTrackNavigation(navigationIdentity)) return;
    const route = resolveAnalyticsRoute(pathname);
    analytics.trackPageView(route.pagePath, { page_name: route.pageName });
  }, [key, pathname]);

  return null;
}
